define.alias("shared/utils/array-methods", "settings/utils/array-methods");